/**
 * Extracts a timer duration in seconds from a step's instruction text.
 * Supports: "20 minutes", "1h30", "1h 30min", "90 seconds", "2 hrs", etc.
 * Returns null if no duration is found.
 */
export function parseDuration(text: string): number | null {
  if (!text) return null;

  const lower = text.toLowerCase();

  // Match "Xh Ym" or "XhYm" or "X hour(s) Y min(s)"
  const hoursMinutes = lower.match(
    /(\d+)\s*(?:h(?:r|rs|ours?)?)\s*(?:(\d+)\s*(?:m(?:in|ins|inutes?)?)?)?/
  );
  if (hoursMinutes) {
    const hours = parseInt(hoursMinutes[1], 10);
    const mins = hoursMinutes[2] ? parseInt(hoursMinutes[2], 10) : 0;
    const total = hours * 3600 + mins * 60;
    if (total > 0) return total;
  }

  // Match "X minutes" or "X min"
  const minutes = lower.match(/(\d+)\s*(?:minutes?|mins?)/);
  if (minutes) {
    const secs = parseInt(minutes[1], 10) * 60;
    if (secs > 0) return secs;
  }

  // Match "X seconds" or "X sec"
  const seconds = lower.match(/(\d+)\s*(?:seconds?|secs?)/);
  if (seconds) {
    const secs = parseInt(seconds[1], 10);
    if (secs > 0) return secs;
  }

  return null;
}
